import { createFileRoute } from "@tanstack/react-router"

import { LaneDetailView } from "@/features/lanes/components/lane-detail-view"
import { laneQueryOptions } from "@/features/lanes/hooks/use-lanes"
import { parseLaneTab } from "@/features/lanes/utils/tabs"
import { warm } from "@/lib/router/warm"

export const Route = createFileRoute("/_shell/voxlane/lanes/$id")({
  validateSearch: (
    search: Record<string, unknown>
  ): { tab?: ReturnType<typeof parseLaneTab> } => ({
    tab: parseLaneTab(search.tab),
  }),
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient }, params }) =>
    warm(queryClient, [
      laneQueryOptions(params.id),
    ]),
  component: LaneDetailRoute,
})

function LaneDetailRoute() {
  const { id } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  // Key by id so the detail view's live-event state resets when the
  // route param changes (the component is otherwise reused).
  return (
    <LaneDetailView
      key={id}
      id={id}
      tab={tab ?? "overview"}
      onTabChange={(next) =>
        void navigate({
          search: { tab: next === "overview" ? undefined : next },
          replace: true,
          resetScroll: false,
        })
      }
    />
  )
}
